import { render, staticRenderFns } from "./zTom_index_buJia.vue?vue&type=template&id=63cc631e&scoped=true&"
import script from "./zTom_index_buJia.vue?vue&type=script&lang=js&"
export * from "./zTom_index_buJia.vue?vue&type=script&lang=js&"
import style0 from "./zTom_index_buJia.vue?vue&type=style&index=0&id=63cc631e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc631e",
  null
  
)

export default component.exports